<template>
  <el-container class="login_bg" type="flex" style="height:100%">
    <el-main>
      <!-- <div class="out-box" v-for="item in productList" :key="item.id">
        <div class="box-card" :class="item.gradeType == 3 ? 'profession' : 'normal'">
          <div class="header" v-if="item.gradeType == 3">
            推荐
          </div>
          <div class="header" v-else>
          </div>
          <el-card shadow="hover">
            <img :src="require('@/assets/images/profession.png')" alt="闪销云" v-if="item.gradeType == 3">
            <img :src="require('@/assets/images/flagship.png')" alt="闪销云" v-if="item.gradeType == 2">
            <img :src="require('@/assets/images/normal.png')" alt="闪销云" v-if="item.gradeType == 1">
            <div class="title">{{ code.gradeType[item.gradeType] }}</div>
            <div class="subject">{{ item.subject }}</div>
            <div class="price" :class="item.gradeType == 3 ? 'title_profession' : ''">¥{{ item.unitPrice }}<span
                class="year">/{{
                  code.termUnit[item.termUnit] }}</span></div>
            <div class="btns">
              <el-button class="yellow_btn" v-if="item.buttonType == 1" @click="handleBuy(item.packageSn)">
                {{ code.buttonType[item.buttonType] }}</el-button>
              <el-button class="yellow_btn_line" v-else-if="item.buttonType == 2" @click="handleTry(item.packageSn)">
                {{ code.buttonType[item.buttonType] }}</el-button>
              <el-button class="yellow_btn" v-else @click="dialogVisible = true">{{ code.buttonType[item.buttonType] }}
              </el-button>
            </div>
          </el-card>
          <div class="desc">
            <div v-html="item.packageContent"></div>
          </div>
        </div>
      </div> -->

      <div :class='[ item?.cardStatus  ? "member-box-click" : "","member-box"]'  v-for="item in productList" :key="item.id" @click="handleCard(item,index)">
        <div class="mem-title">Edition</div>
        <div class="mem-content">
          <div class="title-s center-box">{{code.gradeType[item.gradeType]}}</div>
          <div class="price-s center-box"><span>￥{{ item.unitPrice }}</span>/年</div>
          <div class="int-s center-box">{{ item.subject }}</div>
          <div class="buy-btn">
            <el-button class="btn-s" v-if="item.buttonType == 1" @click="handleBuy(item.packageSn)">
                {{ code.buttonType[item.buttonType] }}</el-button>
              <el-button class="btn-s" v-else-if="item.buttonType == 2" @click="handleTry(item.packageSn)">
                {{ code.buttonType[item.buttonType] }}</el-button>
              <el-button class="btn-s" v-else @click="dialogVisible = true">{{ code.buttonType[item.buttonType] }}
              </el-button>
          </div>
          <div class="privilege-list">
             <div class="priviege-list-icon">
               <div class="privi-each" v-for="item in item.packageContent.split('<p>').length - 1" :key="item">
                 <img src="../../assets/images/dui.png" alt="">
               </div>
             </div>
             <div class="priviege-list-content">
               <div v-html="item.packageContent"></div>
             </div>
          </div>
        </div>
      </div>


      <el-dialog title="联系我们" :visible.sync="dialogVisible" width="60%" center>
        <div class="content">
          请联系我们{{ customerServiceNumber }}！
        </div>
      </el-dialog>
    </el-main>
    <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </el-container>
</template>
<script>
import {
  getProductList,
  getPackageFree
} from '@/api.js'
import {
  mapState
} from 'vuex'
export default {
  name: "SystemProduct",
  data() {
    return {
      text: '',
      isPay: 0,
      dialogVisible: false,
      productList: '',
      btnDisabled: false,
    }
  },
  created() {
    this.getProductList()
  },
  mounted() { },
  methods: {
    getProductList() {
      getProductList({
        appCategoryId: 1,
        packageType: 1
      }).then(res => {
        if (res.code == 0) {
          this.productList = res.data.list ? res.data.list : []
          var len = res.data?.list.length % 2 == 0 ? res.data?.list.length / 2 : parseInt(res.data.list?.length / 2 ) + 1;
           this.productList.forEach((item, index) => {
               if(index + 1 == len){
                  item['cardStatus'] = true; 
               }else {
                  item['cardStatus'] = false;
               }
           })
          // let price = 0
          // let maxPriceIndex = 0
          // this.productList.forEach((item, index) => {
          //   item['isMaxPrice'] = false
          //   if (item.unitPrice > price) {
          //     price = item.unitPrice
          //     maxPriceIndex = index
          //   }
          // })
          // this.productList[maxPriceIndex]['isMaxPrice'] = true
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleBuy(packageSn) {
      if (this.access_token !== '') {
        this.$router.push({
          path: '/system/software_purchase',
          query: {
            packageSn: packageSn
          }
        })
      } else {
        this.$router.push({
          path: '/login'
        })
      }
    },
    handleCard(val){
       var newArr = [];
      this.productList.forEach((item) => {
        if( val.id == item.id){
          item['cardStatus'] = true; 
          newArr.push(item)
        }else {
          item['cardStatus'] = false;
          newArr.push(item)
        }
      })
      this.productList = newArr
    },
    handleTry() {
      if (this.access_token !== '') {
        this.btnDisabled = true
        const location = window.location.href.indexOf('192.168.0.')
        const location200 = window.location.href.indexOf('gogit.52shanpai.com')
        const locationP = window.location.href.indexOf('dealer.52shanpai.com')
        let locationHref
        if (location != -1) {
          locationHref = 'http://192.168.0.102:5173/'
        } else if (location200 != -1) {
          locationHref = 'http://gogit.52shanpai.com:1240/'
        } else if (locationP != -1) {
          locationHref = 'https://dealer.52shanpai.com:9191/'
        }
        getPackageFree({}).then(res => {
          if (res.code == 0) {
            window.location.href = locationHref
          } else {
            this.$message.error(res.message)
          }
          this.btnDisabled = false
        })
      } else {
        this.$router.push({
          path: '/login'
        })
      }
    }
  },
  computed: {
    ...mapState({
      indexPath: state => state.indexPath,
      code: state => state.code,
      access_token: state => state.access_token,
      customerServiceNumber: state => state.customerServiceNumber
    }),
  },
}
</script>

<style scoped lang="scss">
.el-container {
  flex-direction: column;
  background-color: #F6F7FB;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: #B6B6B6;
    padding: 20px 0;
    a{
      color: #B6B6B6;
    }
  }
}

.el-main {
  display: flex;
  flex-direction: row;
  // align-items: center;
  justify-content: center;
}

.out-box {
  width: 392px;
  height: 709px;
  margin-right: 32px;
}

.out-box:last-child {
  margin-right: 0;
}

.box-card {
  width: 380px;
  height: 667px;
  box-sizing: border-box;
  width: 392px;
  height: 709px;
  border-radius: 12px;
  margin: 0 auto;

  .header {
    text-align: center;
    color: #FFFFFF;
    height: 47px;
    line-height: 47px;
  }
}

.profession {
  background: linear-gradient(180deg, #0163F5 0%, #01B9FB 100%);
}

.normal {
  background: rgba(250, 250, 250, 0);

}

.desc {
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 21px;
  padding-left: 26px;
}

.el-card {
  width: 380px;
  height: 372px;
  box-sizing: border-box;
  background: #FFFFFF;
  box-shadow: 0px 8px 16px 0px rgba(149, 157, 165, 0.15);
  border-radius: 12px 12px 12px 12px;
  opacity: 1;
  margin-bottom: 48px;
  margin-left: 6px;

  img {
    width: 48px;
    height: 48px;
    vertical-align: bottom;
    margin-right: 12px;
  }

  .title {
    display: inline-block;
    font-size: 32px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1B283C;
  }

  .subject {
    font-size: 18px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C6066;
    margin: 15px 0 63px 0;
  }

  .price {
    font-size: 48px;
    font-family: DIN Black-Regular, DIN Black;
    font-weight: 400;
    color: #1B283C;
    margin-bottom: 32px;
  }

  .year {
    font-size: 14px;
  }

  .title_profession {
    color: #0177F9;
  }

  .btns {
    margin-top: 20px;

    .el-button {
      width: 332px;
      height: 55px;
      font-size: 20px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      line-height: 30px;
    }
  }

}

.content {
  text-align: center;
  font-size: 30px;
}

.member-box {
  font-family:  "Microsoft YaHei";
  width: 420px;
  border-radius: 12px;
  margin-right: 20px;
  
  .mem-title {
    height: 130px;
    background: #EEF0FB;
    border-radius: 12px;
    color: #021F3E;
    font-size: 20px;
    text-align: center;
    line-height: 50px;
  }

  .mem-content {
    height: 777px;
    background: #FFFFFF;
    border-radius: 12px;
    margin-top: -80px;
    border: 3px solid transparent;
    transition: transform 0.6s ease-in-out;
   
    .center-box {
      text-align: center;

    }

    .title-s {
      color: #021F3E;
      font-weight: bold;
      font-size: 32px;
      padding-top: 50px;
      padding-bottom: 30px;
    }

    .price-s {
      color: #0277F9;
      font-size: 21px;
      margin-bottom: 10px;

      span {
        font-size: 48px;
        font-weight: bold;
      }
    }

    .int-s {
      color: #4C4C4C;
      font-size: 24px;
    }

    .buy-btn {
      text-align: center;
      margin-top: 50px;

      .btn-s {
        width: 330px;
        height: 80px;
        background-color: #0277F9;
        color: #FFFFFF;
        margin: 0 auto;
        font-size: 24px;
      }
    }
    .privilege-list{
      margin-left: 45px;
       display: flex;
       flex-direction: row;

       .priviege-list-icon {
         display: flex;
         flex: 0.1;
         flex-direction: column;
          
         .privi-each{
            display: flex;
            align-items: center;
            font-size: 24px;
            color: #021F3E;
            margin-top: 28px;
            // margin-left: 18px;
            img{
              width: 36px;
              height: 36px;
              margin-right: 18px;
            }
          }
        }
        .priviege-list-content{
          display: flex;
          flex: .9;
          flex-direction: column;
          line-height: 40px;
          font-size: 24px;
        }
        .priviege-list-content {
          p {
              margin:  0  0;
              font-size: 24px;
            }
        }

    }

  } 

}

.member-box-click {
    cursor: pointer;

    .mem-content {
      border-bottom: 3px solid #0468D7;
      border-left: 3px solid #0468D7;
      border-right: 3px solid #0468D7;
    }

    .mem-title {
      color: #fff;
      background: #0468D7;
    }
}

</style>